const environment = {
    // apiUrl: 'https://localhost:44325/api/',  // local
    // apiCarparkUrl: 'https://localhost:44325/api/',  // Carpark local

    apiUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // VPS
    apiCarparkUrl: 'https://api-carpark.objective-faraday.119-59-118-127.plesk.page/api/',  // VPS
    apiReport: 'https://report.objective-faraday.119-59-118-127.plesk.page/', // VPS

    // apiUrl: 'https://lpn-api.fs-omc.io/api/',  // Production
    // apiCarparkUrl: 'https://lpn-apicarpark.fs-omc.io/api/',  // Production
    // apiReport: 'https://lpn-reports.fs-omc.io/', // Production
}
export default environment